import { capitalize } from "lodash-es";
import { KeyboardEvent } from "react";

export const preventFormSubmitOnEnter = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
        event.preventDefault();
    }
};

export enum StringedBooleanType {
    Yes = "yes",
    No = "no",
}

export const YES_NO_OPTIONS: Array<{ label: string; value: StringedBooleanType }> = Object.values(
    StringedBooleanType,
).map((t) => ({ label: capitalize(t), value: t }));
